module.exports = __webpack_public_path__ + "img/successful_payment.98fee5b7.png";